import * as React from "react";
import UhaulStores from "../CustomRedux/UhaulStore";

export class HighlightTaskListView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            serviceBaseUrl: UhaulStores.getState().UhaulReducer.currentUser.serviceBaseUrl,
            numOfMessages: 0, 
            mostRecentSentTimeStamp: new Date().getTime()
        };   
    }

    componentDidUpdate()
    {
        const reducer = UhaulStores.getState().UhaulReducer;

        if(this.props != null && this.props.channelDefinition != null && this.props.task != null)
        {
            if((this.props.task.selected != null && !this.props.selected) || (this.props.task != null && this.props.task.attributes != null && this.props.task.attributes.originalTaskSID != null))
            {
                this.props.task.selected = false;
            }
            else if(this.props.task.selected || this.props.selected)
            {
                if(this.state.numOfMessages > 0)
                {
                    this.props.task["hasNewUnreadMessages"] = false;
                    this.props.task.hasNewUnreadMessages = false;
                }
            }

            if(this.props.conversation != null && (this.props.conversation.isLoadingMessages != null && !this.props.conversation.isLoadingMessages) && this.props.conversation.messages != null)
            {               
                var newMessage = this.props.conversation.messages[this.props.conversation.messages.length - 1];

                if(newMessage != null)
                {               
                    var convertedMessageTimeStamp = newMessage.source.timestamp.getTime();

                    if(newMessage.isFromMe === false && !this.props.task.selected && this.state.mostRecentSentTimeStamp !== convertedMessageTimeStamp)
                    {                
                        
                        if(reducer.currentTaskSwitchTimeStamp.timestamp < convertedMessageTimeStamp)
                        {
                            this.props.task["hasNewUnreadMessages"] = true;
                            this.props.task.hasNewUnreadMessages = true;
                            this.setState({numOfMessages: this.props.conversation.messages.length, 
                                mostRecentSentTimeStamp: convertedMessageTimeStamp
                            });
                        }
                        else if (this.state.mostRecentSentTimeStamp !== reducer.currentTaskSwitchTimeStamp.timestamp)
                        {
                            this.props.task["hasNewUnreadMessages"] = false;
                            this.props.task.hasNewUnreadMessages = false;
                            this.setState({numOfMessages: this.props.conversation.messages.length, 
                                mostRecentSentTimeStamp: reducer.currentTaskSwitchTimeStamp.timestamp
                            });
                        }
                    }

                    if(newMessage.isFromMe)
                    {
                        this.props.task["hasNewUnreadMessages"] = false;
                        this.props.task.hasNewUnreadMessages = false;
                    }
                }
            }
        }
    }

    render() {
        return null;
    }
}